/*
 *   File : footer.js
 *   Author : https://evoqins.com
 *   Description : Footer component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React from 'react';

//Styles
import style from "../../Styles/Component/footer.module.scss";
import { useNavigate } from 'react-router-dom';

// Custom data
const FOOTER_LINKS = {
    general: [
        {
            label: "Terms & Conditions",
            path: "/terms-conditions"
        },
        {
            label: "Support",
            // path: "/support"
        },
        {
            label: "FAQ",
            path: "/faq"
        },
        {
            label: "Privacy",
            path: "/privacy-policy"
        },
    ],
    logged_in: [
        {
            label: "Terms & Conditions",
            path: "/terms-conditions"
        },
        {
            label: "FAQ",
            path: "/faq"
        },
        {
            label: "Refund Policy",
            path: "/refund-policy"
        },
        {
            label: "Privacy Policy",
            path: "/privacy-policy"
        },
    ]
}

const Footer = (props) => {

    const navigate = useNavigate();
    const footer_links = props.type == 1 ? FOOTER_LINKS.logged_in : FOOTER_LINKS.general;

    // handle navigate to related pages
    const _handleNavigate = (path) => {
        if (path) {
            navigate(path);
            if (props.type == 1 && path !== "/faq") {
                props.handlePublicRouter();
            }

            if (props.type == 2) {
                props.handlePublicRouter();
            }
        }
    };

    return (
        <div className={`${props.type === 1 ? style.e_footer_wrapper_loggedIn : `${style.e_footer_wrapper} border-radius-8`}  e-padding-16px-top-res padding-32px-lr pb-3`}>
            <div className='text-center'>
                <img src={require(props.type === 1 ? "../../Assets/Images/Navigation/indvestment-logo.svg" : "../../Assets/Images/Navigation/logo-light.svg").default}
                    draggable={false}
                    className='w-120px'
                    alt='logo' />
            </div>
            <div className={`${props.type === 1 ? "pt-4 pb-3" : "py-3"} d-flex align-items-center flex-wrap justify-content-center gap-3 `}>
                {
                    footer_links.map((link, index) => (
                        <React.Fragment key={index}>
                            <span className={`${props.type === 1 ? 'e-text-outer-space' : 'e-text-white'} text-nowrap e-alt-font-lato e-font-12 e-font-weight-400 line-height-20px text-decoration-hover-underline cursor-pointer`}
                                onClick={() => _handleNavigate(link.path)}>
                                {link.label}
                            </span>
                            {
                                footer_links.length !== index + 1 &&
                                <span className='e-text-lavender-blue vr d-none d-sm-block e-font-12' />
                            }
                        </React.Fragment>

                    ))
                }
            </div>
            <div className='d-flex justify-content-between flex-wrap gap-2'>
                <span className={`${props.type === 1 ? 'e-text-chinese-black' : 'e-text-pale-lavender'} e-alt-font-lato e-font-12 e-font-weight-400 line-height-20px`}>
                    {new Date().getFullYear()} © Indvestment All Rights Reserved
                </span>

                <span className={`${props.type === 1 ? 'e-text-chinese-black' : 'e-text-pale-lavender'} e-alt-font-lato e-font-10 e-font-weight-400 line-height-20px`}>
                    Designed and Developed by
                    <a href="https://evoqins.com/"
                        target='_blank'
                        className='text-reset text-decoration-none'>
                        <span className='text-decoration-hover-underline px-1'>
                            Evoqins Pvt Ltd
                        </span>
                    </a>
                </span>
            </div>
        </div>
    )
}

export default Footer;
